<template>
    <DefaultTemplate :model="model">
        <div class="container">
            <div class="mt-12 mb-8">
                <Breadcrumbs :breadcrumbs="model.breadcrumbs" className="text-grey-400" />
            </div>
            <div class="block lg:flex">
                <div class="w-full lg:w-3/4 pr-0 lg:pr-4">
                    <article class="p-4 md:px-10 md:py-4 lg:px-20 lg:py-10 mb-4 bg-white">
                        <h1 v-epi-edit="'Name'" class="mb-2">{{ model.name }}</h1>
                        <div v-epi-edit="'MainBody'" id="main-body" class="main-body my-4 article" v-html="this.model.mainBody" />
                    </article>
                    <ul class="bg-white -mt-5 p-4">
                        <li v-for="categorizedLink in model.categorizedLinks" :key="categorizedLink.id">
                            <Accordion :title="categorizedLink.category" :preopen="openShortcut(categorizedLink.id)">
                                <ul>
                                    <li v-for="link in categorizedLink.links" :key="link.id">
                                        <b><a :href="link.url">{{link.heading}}</a></b>
                                        <br />
                                        {{link.linkDescription}}
                                        <hr class="my-4 lg:my-10" />
                                    </li>
                                </ul>
                            </Accordion>
                        </li>
                    </ul>
                </div>
                <aside class="w-full lg:w-1/4 pr-0 lg:pl-4 mb-4">
                    <div class="p-5 mb-6 bg-white">
                        <div class="flex justify-end mt-6 print:hidden">
                            <Sharing />
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    </DefaultTemplate>
</template>

<script>
import Breadcrumbs from '@/Scripts/components/organisms/Breadcrumbs/breadcrumbs.vue';
import Sharing from '@/Scripts/components/atoms/Sharing/Sharing.vue';
import ArticleBox from '@/Scripts/components/atoms/ArticleBox/ArticleBox.vue';
import Accordion from '@/Scripts/components/atoms/Accordion/Accordion.vue';

export default {
    props: ['model'],
    components: {
        Breadcrumbs,
        Sharing,
        ArticleBox,
        Accordion
    },
    methods: {
        openShortcut(id) {
            let hash = window.location.hash;
            hash = hash.substring(1);
            if (id === hash) {
                return true;
            }
            return false;
        }
    }
};
</script>
